import { useMemo } from 'react';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import type { IncidentExperimentTraitsResourceData } from '@atlassian/jira-router-resources-software-incidents/src/services/types.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseResourceReturn } from './types.tsx';

export const useIncidentExperimentTraits =
	(): UseResourceReturn<IncidentExperimentTraitsResourceData> => {
		const { data, loading, error } = useResource(incidentExperimentTraitResource);

		return useMemo<UseResourceReturn<IncidentExperimentTraitsResourceData>>(
			() => ({
				data: data || { cohort1: false, cohort2: false },
				loading,
				error,
			}),
			[data, loading, error],
		);
	};
